var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-stage',{attrs:{"asset":"/assets/stages/stage-2.jpg"}}),_c('news-content'),_c('project-gallery'),_c('biography-content'),_c('awards-content'),_c('exhibition-content'),_c('contact-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }